<template>
		<v-row>
		<v-col>
			<v-card outlined>
				<v-card-title
					class = "justify-center secondary pa-0 body-1 white--text"
				>
					<v-icon
						small
						color = "error"
						class = "mx-2"
					>
						mdi-album
					</v-icon>
					<span>
						{{ $ml.get('recording') }}
					</span>
					
				</v-card-title>
				<v-card-text
					class = "pa-1 mt-1"
				>
					<div class = "caption grey--text text--darken-1 px-1 pb-2">
						<v-icon x-small class = "mr-1">mdi-information-outline</v-icon>
						Estos ajustes son <b>globales</b>: aplican a todas las cámaras a la vez. El selector de cámara y los botones de abajo son acciones de <b>mantenimiento por cámara</b>, no configuración.
					</div>
					<v-row>
						<template v-for = "(item_info, idx_info) of info_fields">
							
							<v-col
								:md  = "item_info.col ? item_info.col :  6"
								:key = "idx_info"
							>
								<v-text-field
									dense
									outlined
									hide-details
									v-show 	  = "show[item_info.show_key]"
									:type 	  = "item_info.type"
									v-model   = "info[item_info.key]"
									:label 	  = "$ml.get(item_info.text)"
									:value 	  = "item_info.value ? item_info.value : ''"
									v-if 	  = "['number', 'text'].includes(item_info.type)"
								>	
									<template slot = "prepend-inner">						
										<v-icon 
											small 
											v-text = "item_info.icon" 
											class  = "pt-1"

										></v-icon>
									</template>	
									<template v-slot:append>
										<v-btn
											small
											color = "primary"
											v-show = "item_info.append"
										>
											{{ item_info.append }}
										</v-btn>
									</template>
									<template v-slot:append-outer>
										<v-tooltip
											bottom
											max-width = "320"
											v-if = "item_info.tip"
										>
											<template v-slot:activator = "{ on, attrs }">
												<v-icon
													small
													color  = "grey lighten-1"
													v-bind = "attrs"
													v-on   = "on"
												>mdi-help-circle-outline</v-icon>
											</template>
											<span>{{ item_info.tip }}</span>
										</v-tooltip>
									</template>
								</v-text-field>

								<v-card outlined 
									class  	  = "pa-0 caption pb-1 pl-1" 
									height 	  = "40"
									v-else-if = "item_info.type == 'switch'"
								>
									<v-switch			
										dense						
										false-value
										hide-details
										class 			= "mt-1"			
										v-model 		= "info[item_info.key]"						
										:label 			= "$ml.get(item_info.text)"
										:prepend-icon 	= "item_info.icon"
									></v-switch>
										<!-- v-if="item_field.type == 'switch'"						 -->
										<!-- class="pt-0" -->
								</v-card>
								<searcher
									v-show 	  			= "show[item_info.show_key]"
									v-else-if 			= "item_info.type == 'select_searcher'"
									:info_to_component 	= "item_info"
									:info_to_list  	   	= "render_listed(item_info.list)"
									@receive_info	   	= "info[item_info.key] = $event"
								></searcher>

								<v-divider
									v-else-if = "item_info.type == 'line'"
								></v-divider>
							</v-col>
						</template>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>

					<v-progress-linear
				      	indeterminate
				      	v-show = "loading"
				      	color  = "primary"
				    ></v-progress-linear>
					<v-btn
						x-small
						@click = "save"
						color  = "primary"
						v-text = "$ml.get('update')"
				      	v-show = "!loading"
					></v-btn>
					<v-spacer></v-spacer>
					<v-btn-toggle
						v-show = "show.options_record"
					>
						<template
							v-for = "(opt_btn, idx_btn) of options_records"
						>
							
							<v-btn
								x-small
								:key  	= "idx_btn + 'records_btn'"
								:color 	= "opt_btn.color"
								:title 	= "opt_btn.tip"
								v-text 	= "opt_btn.text"
								@click 	= "actions(opt_btn.action)"
							></v-btn>
						</template>
					</v-btn-toggle>
					<v-switch
						dense
						hide-details
						class   = "mt-0 ml-3"
						v-show  = "show.options_record"
						v-model = "apply_all"
						color   = "warning"
						label   = "Aplicar a todas las cámaras"
						title   = "Si está activo, las acciones de mantenimiento (Guardar índice / Limpiar huérfanos) se ejecutan sobre TODAS las cámaras, ignorando el selector."
					></v-switch>
					<v-spacer></v-spacer>
					<v-btn
						x-small
						@click = "actions('confirm_delete')"
						color  = "error"
						v-text = "$ml.get('delete')"
				      	v-show = "!loading"
					></v-btn>

					
					
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import searcher from "@/components/info/searcher.vue"
	export default{
		name : "recordings",
		components  : {
			searcher,	
		},
		data : () => ({
			info 			: {},
			info_fields 	: [
				{
					key 	 : 'timelapse',
					text 	 : 'timelapse',
					type 	 : 'number',
					icon   	 : 'mdi-timelapse',
					append 	 : 'seg',
					enable 	 : true,
					show_key : "timelapse",
					tip 	 : "Duración de cada segmento de video (chunk) en segundos. Aplica a TODAS las cámaras. Ej: 20 → archivos .mp4 de 20s cada uno.",

				},
				{
					key 	 : "server_rtsp", 
					text 	 : 'server_rtsp',
					type 	 : 'text',
					icon   	 : 'mdi-router-network',					
					enable 	 : true,
					show_key : "server_rtsp",
					tip 	 : "Servidor RTSP al que se retransmiten los videos hacia el cloud. Ej: rtsp://cloud.alicesecurity.co:8554",

				},
				{
					key 	 : 'limit_erased_recording',
					text 	 : 'limit_erased_recording',
					type 	 : 'number',
					enable 	 : true,		
					icon   	 : 'mdi-delete-clock',					
					show_key : "limit_erased_recording",					
					tip 	 : "Cuántas grabaciones se borran por ciclo cuando falta espacio en disco. Ej: 5 → borra de a 5 archivos por pasada.",
				},
				{
					key 	 : 'max_buffer',
					text 	 : 'max_buffer',
					type 	 : 'number',
					enable 	 : true,		
					icon   	 : 'mdi-format-line-weight',					
					show_key : "max_buffer",					
					tip 	 : "Límite total de almacenamiento de grabaciones por cámara antes de rotar (borrar las más antiguas), en MB. Ej: 8000 ≈ 8 GB por cámara.",
				},
				{
					key  	 : 'amount_to_delete',
					text 	 : 'amount_to_delete',
					type  	 : 'number',
					icon   	 : 'mdi-delete-outline',
					enable 	 : true,
					show_key : "amount_to_delete",
					tip 	 : "Cuántos registros 'huérfanos' (existen en la BD pero ya no en disco) elimina la limpieza por lote. Ej: 30.",

				},
				{
					key 	 : 'limit_erased_evidences',
					text 	 : 'limit_erased_evidences',
					type 	 : 'number',
					enable 	 : true,
					icon   	 : 'mdi-delete-alert',
					show_key : 'limit_erased_evidences',
					tip 	 : 'Cuántas evidencias (fotos/clips de eventos) se borran por ciclo de limpieza. Ej: 5.',
				},
				{
					key 	 : 'percent_limit_del_evidences',
					text 	 : 'percent_limit_del_evidences',
					type 	 : 'number',
					enable 	 : true,
					icon   	 : 'mdi-harddisk',
					append 	 : '%',
					show_key : 'percent_limit_del_evidences',
					tip 	 : 'Porcentaje de uso de disco a partir del cual se empiezan a borrar evidencias antiguas. Ej: 80 → al llegar al 80% del disco.',
				},
				{
					key 	 : 'rtsp_timeout',
					text 	 : 'rtsp_timeout',
					type 	 : 'number',
					enable 	 : true,
					icon   	 : 'mdi-timer-alert',
					append 	 : 'seg',
					show_key : 'rtsp_timeout',
					tip 	 : 'Timeout de lectura RTSP (seg): si el stream se congela este tiempo, ffmpeg sale y reconecta. Ej: 5. Súbelo a 10 en redes lentas.',
				},
				{
					key  : 'line',
					type : 'line',
					col  : '12',
				},
				{
					key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					show_key 	: 'search',
					visible 	: true,

				},
				/*{
					key : 'enable',
					text : 'enable',
					type : 'switch',
					enable : false,				
				},
				{
					key : 'url',
					text : 'url',
					type : 'text',
					enable : false,
				},
				{
					key : 'port',
					text : 'port',
					type : 'number',
					enable : false,
				},*/
				
			],
			info_item 		: "",
			apply_all 		: false,
			builder 		: ['timelapse','enable', 'max_buffer','amount_to_delete', 'limit_erased_recording', 'limit_erased_evidences', 'percent_limit_del_evidences', 'rtsp_timeout', 'server_rtsp'],
			id_notification : 'recordings',
			bus 			: {},
			loading 		: false,
			options_records  : [
				{
					type   : 'btn',
					action : 'save_record',
					text   : 'save_record',
					color  : 'primary',
					tip    : 'Indexa en la BD los videos que ya están en disco para la cámara seleccionada (recupera grabaciones que existen pero no aparecen en el NVR).'
				},
				
				/*{
					type   : 'btn',
					action : 'start_record',
					text   : 'start_record',
					color  : 'success'
				},*/
				/*{
					type   : 'btn',
					action : 'confirm_del_record',
					text   : 'del_record',
					color  : 'error'
				},*/
				{
					type   : 'btn',
					action : 'confirm_del_record_non_exist',
					text   : 'del_record_non_exist',
					color  : 'error',
					tip    : 'Limpia el índice: borra de la BD los registros cuyo archivo de video ya no existe en disco (huérfanos), para la cámara seleccionada. No borra videos buenos.'
				},
				
			],
			permission 	  : {
				"roles": [1, 2]
			},
			show : {
				options_record   : false,
				max_buffer 		 : false,
				amount_to_delete : false,
				timelapse 		 : true,
				limit_erased_recording  : false,
				limit_erased_evidences  : false,
				percent_limit_del_evidences : false,
				rtsp_timeout 	: false,
				search 			: false,
				server_rtsp 	: false,
			},
			default : {
				amount_to_delete : 30,
				max_buffer 		 : 8000,
				limit_erased_recording  : 5,
				limit_erased_evidences  : 5,
				percent_limit_del_evidences : 80,
				rtsp_timeout 			: 5,
				server_rtsp 			: "rtsp://cloud.alicesecurity.co:8554",
			},
			list_devices 		: [],
		}), // data

		created(){
			this.get_list();
			if (this.$Helper.current_auth_user(this.currentUser, this.permission) && ['parameters', 'settings'].includes(this.$route.name)){
				this.show.options_record  	= true;
				this.show.max_buffer 	  	= true;
				this.show.amount_to_delete  = true;
				this.show.limit_erased_recording  	= true;
				this.show.limit_erased_evidences  	= true;
				this.show.percent_limit_del_evidences = true;
				this.show.rtsp_timeout 		= true;
				this.show.search 			= true;
			}
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
		}, // created

		computed: {
			currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser

		}, // computed

		methods :{
			
			actions(act, item, opt){
				if (act == 'confirm_delete') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_parameter";
				}

				if (['save_record', 'start_record'].includes(act)) {
					this.actions_record(act);
				}

				if (act == 'confirm_del_record') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_record";					
				}
				if (act == 'confirm_del_record_non_exist') {
					
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_record_non_exist";
					
				}
			}, // actions

			get_list(){
				const api    = this.$URL + '/api/v1/parameter/' + 1;
				const api1   = this.$URL + '/api/v1/parameter';
				this.loading = true;
				this.$axios.get( api).then( res => {
					this.loading = false;
					if (res && res.data) {
						this.info = res.data;
						/*if (!this.amount_to_delete) {
							this.info.amount_to_delete 		 = this.default.amount_to_delete;
							this.info.max_buffer 			 = this.default.max_buffer; 					
							this.info.limit_erased_recording = this.default.limit_erased_recording;
						}*/
					}else{
						let info_up = {
							timeoutAlert  			: 5,
							timelapse      			: 20,
							timezone 				: this.$timezone,
							amount_to_delete 		: this.default.amount_to_delete,
							max_buffer 		 		: this.default.max_buffer,
							limit_erased_recording  : this.default.limit_erased_recording,
							server_rtsp 			: this.default.server_rtsp,
						}
						this.$axios.post(api1, info_up).then(ress =>{
							if (ress && ress.data) {
								this.info = info_up;	
								// this.info.amount_to_delete 	= this.default.amount_to_delete;
								// this.info.max_buffer 		= this.default.max_buffer; 					
							}
						}).catch(err => {
							console.log("error create recordings ", err);
							this.$EventBus.$emit('notifications_modal',{
								type 	: 'error',
								message : err 
							});			
						})
						console.log("Not found info recordings", res);
					}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // get list

			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/parameter/' + 1;
				let info_up  = this.$Helper.format_req(this.info, this.builder);
				if (info_up &&  info_up.timelapse) {

					this.loading = true;
					this.$axios.put( api, info_up).then( res => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type : 'updated'
						});
					}).catch( er => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						});
					});
				}else{
					let msg = '';
					if (!info_up.timelapse) {
						msg += this.$ml.get('timelapse');
					}
				
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('required') + ' : ' + msg,
					})
				}
			}, // save

			del(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/parameter/' + 1;				
				this.loading = true;
				this.$axios.delete( api).then( res => {
					this.loading = false;

					this.$EventBus.$emit('notifications_modal',{
						type : 'deleted'
					});
					this.info = {
						name      		 		: 1,
				        enable    		 		: false,
				        amount_to_delete 		: this.default.amount_to_delete,
						max_buffer 		 		: this.default.max_buffer, 		
						limit_erased_recording 	: this.default.limit_erased_recording,		
						server_rtsp 			: this.default.server_rtsp,
				        
					};
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // del

			actions_record(act){
				const api = this.$URL + '/api/v1/parameter/action_record';
				const  { max_buffer, amount_to_delete } = this.info;
				const selected = this.info && this.info.search ? this.info.search : '';
				// Guarda: evitar aplicar a TODAS por accidente (cámara no seleccionada y toggle apagado)
				if (!this.apply_all && !selected) {
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'warning',
						message : 'Selecciona una cámara o activa "Aplicar a todas las cámaras".'
					});
					return;
				}
				let info_up = {
					action : act,
					 max_buffer,
					 amount_to_delete,
					 deviceId 	: this.apply_all ? 'all' : selected,
				}
				this.$axios.post(api, info_up).then(res => {
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'success',
						message : this.apply_all ? 'Acción aplicada a todas las cámaras en segundo plano.' : 'Action taking place in the background. '
					})
				}).catch( er => {
					console.log("Error actions record : ", er);
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'error',
						message : er
					}) 
				})
			}, // actions records
			render_listed (list){
				return this[list];
			}, // render listed

		}, // methods

		mounted(){
			let temp_bus = "notifications_modal" + this.id_notification;
			this.$EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (this.info_item == 'del_parameter') {
						this.del();
					}
					if (['del_record', 'del_record_non_exist'].includes(this.info_item)) {
						this.actions_record(this.info_item)
					}
				}
			});
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, 'recordings');

		}, // beforeDestroy
	};
</script>